/* eslint-disable no-restricted-imports */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import { Badge, Grid, styled, Tooltip } from "@mui/material";
import objectPath from "object-path";
import React, { useEffect, useMemo, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { NavLink, useHistory, withRouter } from "react-router-dom";
import { useHtmlClassService } from "../..";
import ModalSummaryNotice from "../../../../app/components/modals/ModalSummaryNotice";
import NotificationSupp from "../../../../app/components/notificationSupp/NotificationSupp";
import { WORK_FLOW_TYPE } from "../../../../app/config/cacheKey";
import {
  getNoticesResponse,
  noticeSummaryResponse,
} from "../../../../app/models/SupplierNotice.model";
import {
  GetCurrentNotices,
  GetSupplierNoticeSummary,
} from "../../../../app/services/SupplierNotice.service";
import { DropdownTopbarItemToggler } from "../../../_partials/dropdowns/DropdownTopbarItemToggler";
import { connect, useDispatch, useSelector } from "react-redux";
import { setNoticeSummary } from "../../../../app/redux/summaryCount/summaryCountAction";

function CurrentNoticeCmp({ summatyNotice }: CurrentNoticeCmpPropsInterface) {
  const uiService = useHtmlClassService();
  // const [count, setCount] = useState(0);
  // const [hasInstant, setHasInstant] = useState(false);
  const history = useHistory();
  const queryClient = useQueryClient();
  const handleClick = (item: any) => {
    queryClient.setQueryData(WORK_FLOW_TYPE, item.cartableName);

    history.push({
      pathname: `/cartable/${item.cartableName}`,
      state: { refetchStatus: true },
      // search: "test",
    });
  };

  const CustomBadge = styled(Badge)({
    "& .MuiBadge-badge": {
      backgroundColor: "#28a745 !important",
      color: "#fff",
      width: "30px !important",
      height: "30px !important",
      borderRadius: "20px !important",
    },
  });

  const layoutProps = useMemo(() => {
    return {
      light:
        objectPath.get(uiService.config, "extras.user.dropdown.style") ===
        "light",
    };
  }, [uiService]);
  const dispatch = useDispatch();
  const getSupplierNoticeSummaryMutate = useMutation(GetSupplierNoticeSummary, {
    onSuccess: (data: noticeSummaryResponse) => {
      // setCount(data.count);
      // setHasInstant(data.hasInstant);
      dispatch(
        setNoticeSummary({ count: data.count, hasInstant: data.hasInstant })
      );
    },
  });

  const MINUTE_MS = 15 * 60 * 1000;
  useEffect(() => {
    const interval = setInterval(() => {
      // getSupplierNoticeSummaryMutate.mutate();
      // refetch();
    }, MINUTE_MS);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    // getSupplierNoticeSummaryMutate.mutate();
  }, []);
  const mutateCurrentNotice = () => {
    // refetch();
  };

  const [dataNotic, setDataNotic] = useState<getNoticesResponse[]>([]);
  // const { data, isLoading, refetch } = useQuery<getNoticesResponse[]>(
  //   "currentNotice",
  //   GetCurrentNotices,
  //   {
  //     onSuccess(data) {
  //       setDataNotic(data);
  //     },
  //   }
  // );
  const jsonFile = useSelector((state: any) => state.style);

  const [openModel, setOpenModel] = React.useState(false);
  return (
    <Dropdown drop="down" alignRight>
      <Dropdown.Toggle
        as={DropdownTopbarItemToggler}
        id="dropdown-toggle-user-profile"
      >
        <div
          className={"borderLeft-TopBarIcon px-2 cartSummary"}
          onClick={mutateCurrentNotice}
        >
          <ModalSummaryNotice
            openModel={summatyNotice.hasInstant}
            // setOpenModal={setHasInstant}
            count={summatyNotice.count}
          />

          {summatyNotice.count != 0 ? (
            <>
              <Tooltip title=" اطلاعیه ها" arrow>
                <Badge
                  color={jsonFile?.badgeColor}
                  sx={{
                    "&.MuiBadge-badge": {
                      fontWeight: "bold",
                      fontSize: "14px !important",
                      direction: "ltr",
                    },
                  }}
                  badgeContent={
                    summatyNotice.count > 99 ? "+99" : summatyNotice.count
                  }
                >
                  <NotificationsNoneOutlinedIcon
                    className="Icons BorderColor cursorPointer "
                    style={{ width: "30px" }}
                  />
                </Badge>
              </Tooltip>
            </>
          ) : (
            <Tooltip title=" اطلاعیه ها" arrow>
              <NotificationsNoneOutlinedIcon
                className="Icons BorderColor cursorPointer"
                style={{ width: "30px" }}
              />
            </Tooltip>
          )}
        </div>
      </Dropdown.Toggle>

      <Dropdown.Menu
        className=" m-0 dropdown-menu-right dropd
      own-menu-anim dropdown-menu-top-unround dropdown-menu-xl positionDropdownNotify "
        style={{
          padding: "0 10px 0 25px",
          width: "500px",
          border: "1px solid #CFD8DC",
          backgroundColor: "#f7f9ff",
        }}
      >
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          {/* {count != 0 ? ( */}
          <Grid item xs={12}>
            <NavLink to="/notifications">
              <u
                style={{
                  color: "#004BFE",
                  textAlign: "left",
                  marginTop: "10px",
                  display: "block",
                  fontSize: "14px",
                }}
              >
                مشاهده همه اطلاعیه‌ها
              </u>
            </NavLink>
          </Grid>
          <Grid item xs={12} className="ScrollDropNotice">
            {dataNotic.map((item: any) => (
              <NotificationSupp
                data={item}
                isLogin={false}
                setDataNotic={setDataNotic}
              />
            ))}
          </Grid>
          {/* ) : (
            <></>
          )} */}
        </Grid>
      </Dropdown.Menu>
    </Dropdown>
  );
}

const TOKEN_KEY = "token";
const handelToken = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.setItem("setActivePage", "Wellcome");
};
interface CurrentNoticeCmpPropsInterface {
  summatyNotice: any;
}
const mapStateToProps = ({ summatyNotice }: CurrentNoticeCmpPropsInterface) => {
  return { summatyNotice };
};

export default withRouter(connect(mapStateToProps)(CurrentNoticeCmp));
